var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.751,
    height: 15.833,
    viewBox: "0 0 23.751 15.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M27.834,96c4.427,0,8.778,2.637,11.638,7.055a1.594,1.594,0,0,1,0,1.723c-2.821,4.417-7.172,7.055-11.639,7.055-4.452,0-8.791-2.632-11.607-7.04a1.577,1.577,0,0,1,.029-1.755C19.423,98.5,23.534,96,27.834,96Zm0,14.25c3.924,0,7.777-2.365,10.307-6.326-2.564-3.973-6.418-6.34-10.307-6.34-3.767,0-7.417,2.258-10.277,6.357C20.085,107.891,23.925,110.25,27.834,110.25Z",
    transform: "translate(-15.974 -96)",
    fill: "#006664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M-11.25-16A4.755,4.755,0,0,1-6.5-11.25,4.755,4.755,0,0,1-11.25-6.5,4.755,4.755,0,0,1-16-11.25,4.755,4.755,0,0,1-11.25-16Zm0,7.917A3.17,3.17,0,0,0-8.083-11.25a3.17,3.17,0,0,0-3.167-3.167,3.17,3.17,0,0,0-3.167,3.167A3.17,3.17,0,0,0-11.25-8.083Z",
    transform: "translate(23.126 19.167)",
    fill: "#006664"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.4085edacf2f967c73ff1ae41f703d879.svg";
export { ForwardRef as ReactComponent };